<template>
  <div class="naver_ad_header">
    <strong class="search_keyword">{{ searchQuery }} 관련 광고</strong>
    <div class="ad_mark_wrap">
      <i class="ico_info" @click="toggleInfo"></i>
    </div>
    <div class="info_desc" :class="{ show: isInfoVisible }">
      <button type="button" class="btn_close_info" aria-label="광고 정보 닫기" @click="closeInfo"></button>
      <p>광고 노출기준은 검색어에 대한 연관성과<br>광고주의 입찰가이며, 이미지 등 추가 링크는 등록한<br>
	      경우에만 기준에 따라 노출됩니다.
      </p>
      <div class="divider"></div>
      <a :href="helpUrl" target="_blank" rel="noopener noreferrer">도움말</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NaverAdHeader',
  props: {
    searchQuery: {
      type: String,
      required: true
    },
    helpUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isInfoVisible: false
    }
  },

  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },

  methods: {
    toggleInfo(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isInfoVisible = !this.isInfoVisible;
    },

    closeInfo(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isInfoVisible = false;
    },

    handleOutsideClick(e) {
      const infoDesc = this.$el.querySelector('.info_desc');
      const clickedInsideInfoDesc = infoDesc && infoDesc.contains(e.target);

      if (!clickedInsideInfoDesc) {
        this.isInfoVisible = false;
      }
    }
  }
}
</script>